exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidemenu {\n  min-height: calc(100% - 50px);\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3); }\n  .sidemenu__item {\n    -webkit-transition: .2s background-color linear;\n    transition: .2s background-color linear; }\n  .sidemenu__item--link {\n      width: 100%;\n      height: 50px;\n      display: block;\n      padding: 15px 0 0 25px;\n      cursor: pointer;\n      border-top: 1px solid #e3e9ea;\n      -webkit-box-sizing: border-box;\n      box-sizing: border-box; }\n  .sidemenu__item--link .margin--left {\n        margin-left: 5px; }\n  .sidemenu__item:hover {\n      background-color: #FAFAFA; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/pages/pages.component.scss
// module id = ../../../../../src/app/pages/pages/pages.component.scss
// module chunks = main